<main id="main-content" class="main-content">
  <div class="subtitle" style="font-size: 14px;"><span class="red">*</span>Indicates required field</div>
  <h2 class="form-header">5. Assessment Cost </h2>

  <mat-card [formGroup]="form">
    <div class="subtitle" style="font-weight: 700;"><span class="red">*</span>Assessment Cost</div>
    <p style="color: #727272; margin-left: 5px; margin-top: 10px; font-size: 16px;">This cost is for the assessment for all forests included in this report.
    </p>
    <mat-form-field appearance="outline" class="example small-field" style="max-width: 200px;">
      <input class="right" id='assessmentCost' formControlName="assessment_cost"
        matInput aria-label="assessment_cost" placeholder="$0.00">
    </mat-form-field>
  </mat-card>
</main>